import React, { Component } from 'react'
import * as debounce from 'lodash.debounce'
import { connect } from 'react-redux'
import QuickSearch from '../Components/QuickSearch'
import {
    query,
    setSearchQuery,
    toggleShowFullForm,
    handleKeyDown,
} from '../Actions/QuickSearch.action'

class QuickSearchContainer extends Component {
    constructor(props) {
        super(props)
        this.state = { ...props }
        this.clickHandler = this.clickHandler.bind(this)
        this.lastClickedNode = null
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.clickHandler)
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.clickHandler)
    }

    clickHandler(event) {
        const { showFullForm, toggleShowFullForm } = this.props
        if (
            this.searchContainer &&
            !this.searchContainer.contains(event.target)
        ) {
            showFullForm && toggleShowFullForm()
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.selectedItem !== prevProps.selectedItem) {
            document
                .querySelector('.quick-search-result__item--selected')
                .scrollIntoView({
                    behavior: 'smooth',
                    block: 'end',
                    inline: 'nearest',
                })
        }
    }

    render() {
        const { query } = this.props
        const searchUrl =
            window.__litium.quickSearchUrl +
            (query.length > 0 ? `?q=${query}` : '')
        return (
            <div ref={(elem) => (this.searchContainer = elem)}>
                <QuickSearch {...{ ...this.props, searchUrl }} />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        query: state.quickSearch.query,
        result: state.quickSearch.result,
        showResult: state.quickSearch.showResult,
        showFullForm: state.quickSearch.showFullForm,
        selectedItem: state.quickSearch.selectedItem,
    }
}

// debouncing function to 200ms so we don't send query request on every key stroke
const debouncedQuery = debounce((dispatch, text) => dispatch(query(text)), 200)

const mapDispatchToProps = (dispatch) => {
    return {
        onSearch: (text) => {
            dispatch(setSearchQuery(text))
            debouncedQuery(dispatch, text)
        },
        toggleShowFullForm: () => dispatch(toggleShowFullForm()),
        onKeyDown: (event, opt) => dispatch(handleKeyDown(event, opt)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(QuickSearchContainer)
